import type { RecentConversationMessage } from "@albertine/types/openapi/lmt";
import Icon from "../Common/Icon";

type Props = {
    message: Pick<RecentConversationMessage, "message" | "attachments"> | null;
    className?: string;
    quoted: boolean;
};

const MessageDescription = function MessageDescription({
    message,
    className,
    quoted,
}: Props) {
    if (!message) return <span className={className} />;
    if (message.attachments && message.attachments.length > 0) {
        const attachment = message.attachments[0];

        if (attachment?.mimeType?.startsWith("audio")) {
            return (
                <span className={className}>
                    <Icon.Mic.XSmall />
                    Audio
                </span>
            );
        }
        if (attachment?.mimeType?.startsWith("image")) {
            return (
                <span className={className}>
                    <Icon.PhotoCamera.XSmall />
                    Photo
                </span>
            );
        }

        return (
            <span className={className}>
                <Icon.AttachFile.XSmall />
                Attachment
            </span>
        );
    }
    return (
        <span className={className}>
            {quoted && '"'}
            {message.message}
            {quoted && '"'}
        </span>
    );
};

export default MessageDescription;
